import { App } from "antd";
import { useTranslation } from "react-i18next";
import { ApiError } from "../../api/client";
import { UploadError } from "../../api/evidence";

/** Messaggi uniformi: errori API (ApiError.message) e errori di upload client. */
export function useNotify() {
  const { message } = App.useApp();
  const { t } = useTranslation();
  return {
    ok: (text?: string) => void message.success(text ?? t("saved")),
    warn: (text: string) => void message.warning(text),
    fail: (e: unknown) => {
      const text = e instanceof UploadError ? t(e.key) : e instanceof ApiError ? e.message : e instanceof Error ? e.message : String(e);
      void message.error(text);
    },
  };
}
